import { gql } from '@apollo/client';
import ContentCard from '../ContentCard/ContentCard.pim';
import TextCard from '../TextCard/TextCard';
import ImageCard from '../ImageCard/ImageCard.pim';

export const CardContainerFragment = gql`
  fragment CardContainerFragment on CardContainer {
    ... on CardContainer {
      __typename
      backgroundColor
      cardWidth
      cards {
        __typename
        ...ContentCardFragment
        ...TextCardFragment
        ...ImageCardFragment
      }
      header
      headerAlignment
      overflowProperties
      subheader
      title
    }
  }
  ${ContentCard.fragment}
  ${TextCard.fragment}
  ${ImageCard.fragment}
`;

export default {};
